import { useCallback } from 'react';
import APIRequest from "../../../../Services/commonAPIConsumer";
import { useDispatch } from 'react-redux';
import { storeIdentifyLeakers,storeIDLeakerLookupData,storeTemplateIDLeakerLookupData,storeTemplateIdentifyLeakers, setIDLeakersType,setDocumentTemplates } from "../../../../StateManagement/actions";
import { useNavigate } from 'react-router-dom';

export const useFetchIdentifyLeakers = (startLoading, stopLoading) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const getContentSecuritySettings = useCallback(async () => {
	startLoading();
        try {
            let url = `${process.env.REACT_APP_API +
                process.env.REACT_APP_API_GetContentSecuritySettingDetails
                }?SettingFor=${'User'}&Lang=${localStorage.getItem(
                    'language'
                )}&role=${'User'}&userEmail=${localStorage.getItem('UserName')}`;

            const response = await APIRequest.GET('', url);
            if (response && response.errorMessage) {
                console.error(
                    'Error fetching content security settings:',
                    response.errorMessage
                );
                return;
            }

            const idLeakers=response && response?.setting[0]?.commonContentSecuritySetting?.find((item)=>item.type==="IDLeakers")?.keyValue;
            const idLeakersType=response && response?.setting[0]?.commonContentSecuritySetting?.find((item)=>item.type==="IDLeakersType")?.keyValue;
            const idLeakersAdmin=response && response?.isContentSecurity;
            // localStorage.setItem("IDLeakersType",idLeakersType);
            dispatch(setIDLeakersType(idLeakersType));
            dispatch(setDocumentTemplates(response?.docTemplateOptions));
            if(idLeakers==="false" || idLeakersAdmin == "false"){
                return false;
            }
            const cipherText = response?.setting[0]?.cipherText;
            const floatingText = response?.setting[0]?.floatingText;

            dispatch(storeIdentifyLeakers({ cipherText, floatingText }));
            dispatch(storeTemplateIdentifyLeakers({ cipherText, floatingText }));
            return true;
        } catch (error) {
            console.error('Error in getContentSecuritySettings:', error);
            throw error;
        } finally{
			stopLoading();
		}
    }, []);

    const fetchLookupData = useCallback(async () => {
        try {
            const url = `${process.env.REACT_APP_API}${process.env.REACT_APP_API_GetLookUpDetails}`;
            const response = await APIRequest.GET(
                '',
                `${url}?Lang=${localStorage.getItem('language')}`
            );

            if (response === 'Server maintenance') {
                navigate("/maintenance");
            }

            if (!response || response === 'Failed to fetch') {
                return {};
            }

            const lookupData = {
                cipherTextOptions: response.bindLookUpData.filter(
                    (data) => data.fieldName === 'CipherText'
                ),
                opacityOptions: response.bindLookUpData.filter(
                    (data) => data.fieldName === 'Opacity'
                ),
                cipherViewOptions: response.bindLookUpData.filter(
                    (data) => data.fieldName === 'CipherView'
                ),
                cipherPatternOptions: response.bindLookUpData.filter(
                    (data) => data.fieldName === 'CipherPattern'
                ),
                shapeOptions: response.bindLookUpData.filter(
                    (data) => data.fieldName === 'Shape'
                ),
                floatingTextOptions: response.bindLookUpData.filter(
                    (data) => data.fieldName === 'FloatingText'
                ),
                suffixPrefixOptions: response.bindLookUpData.filter(
                    (data) => data.fieldName === 'SuffixPrefixFloatingText'
                ),
                navigationOptions: response.bindLookUpData.filter(
                    (data) => data.fieldName === 'Navigation'
                ),
                fontColorOptions: response.bindLookUpData.filter(
                    (data) => data.fieldName === 'FontColor'
                ),
                fontSizeOptions: response.bindLookUpData.filter(
                    (data) => data.fieldName === 'FontSize'
                ),
                speedOptions: response.bindLookUpData.filter(
                    (data) => data.fieldName === 'Speed'
                )
            };
            dispatch(storeIDLeakerLookupData({ value: lookupData }));
            dispatch(storeTemplateIDLeakerLookupData({ value: lookupData }));
        } catch (error) {
            console.log('Error in fetchLookupData:', error);
            //throw error;
        }
    }, []);
    return {
        getContentSecuritySettings,
        fetchLookupData
    };
};

export default useFetchIdentifyLeakers;
